import { ReactNode } from 'react'
import useMyProductForm from '@src/hooks/product/form/useProductForm'
import { FormProvider } from 'react-hook-form'
import TitleForm from './TitleForm'
import ChallengeForm from './ChallengeForm'
import PackageForm from './PackageForm'
import NormalPriceForm from './NormalPriceForm'
import TypeForm from './TypeForm'
import BannerForm from './BannerForm'
import SampleProofForm from './SampleProofForm'
import DescriptionForm from './DescriptionForm'
import SubmitBtn from './SubmitBtn'
import SectionBlock from './SectionBlock'
import VariantForm from './VariantForm'
import SkuTable from './SkuTable'

type PropsType = {
	children: ReactNode
}
const ProductForm = ({ children }: PropsType) => {
	const { methods, handleSubmit } = useMyProductForm()
	return (
		<FormProvider {...methods}>
			<form onSubmit={handleSubmit}>{children}</form>
		</FormProvider>
	)
}

ProductForm.ChallengeForm = ChallengeForm
ProductForm.PackageForm = PackageForm
ProductForm.SubmitBtn = SubmitBtn
ProductForm.SectionBlock = SectionBlock
ProductForm.TitleForm = TitleForm
ProductForm.TypeForm = TypeForm
ProductForm.NormalPriceForm = NormalPriceForm
ProductForm.DescriptionForm = DescriptionForm
ProductForm.BannerForm = BannerForm
ProductForm.SampleProofForm = SampleProofForm
ProductForm.VariantForm = VariantForm
ProductForm.SkuTable = SkuTable

export default ProductForm
